import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

console.log(
  '%c ',
  'background-image: url("https://cultofthepartyparrot.com/parrots/hd/parrot.gif"); padding: 120px',
);
console.log(
  '%cThanks for coming everyone!',
  'font-size: 24px; color: #f1f1f1;',
);

createApp(App)
  .use(store)
  .use(router)
  .mount('#app');
